export const projectAssignCrewsAddEnUS = {
  selectCrew: 'Select Crew',
}

export const projectAssignCrewsAddEsMX = {
  selectCrew: 'Seleccionar Equipo',
}
